/**
 * @description: 意向标签生成，催收：collectionTags、营销：marketingTags、信审：infoCheckTags
 */
import collectionTags from './collectionTags' // 催收标签统计表
import marketingTags from './marketingTags' // 营销标签统计表
import infoCheckTags from './infoCheckTags' // 信审标签统计表
import codTags from './codTags' // cod标签统计表
import InboundTags from './InboundTags' // inbound标签统计表

import enLocale from '@/lang/en' // 中文语言包
import zhLocale from '@/lang/zh' // 英文语言包
import baLocale from '@/lang/ba' // 印尼语言包
import esLocale from '@/lang/es' // 印尼语言包
import vueThat from '@/main' // 引入vue

/**
 * @description: 生成意向标签
 * @param {*} collection // 后端返回催收标签
 * @param {*} marketing  // 后端返回营销标签
 * @param {*} info_check // 后端返回信审标签
 * @param {*} company // 公司
 * @return {*}
 */

export function getIntentionTags(intention_annotate) {
  let langueObject = {
    zh: zhLocale,
    en: enLocale,
    ba: baLocale,
    es: esLocale
  }
  const { collection, marketing, info_check, cod, Inbound } = intention_annotate
  if (collection) getLangueTags(collection, 'collectionTags', collectionTags)
  if (marketing) getLangueTags(marketing, 'marketingTags', marketingTags)
  if (info_check) getLangueTags(info_check, 'infoCheckTags', infoCheckTags)
  if (cod) getLangueTags(cod, 'codTags', codTags)
  if (Inbound) getLangueTags(Inbound, 'InboundTags', InboundTags)

  function getLangueTags(statis, langueKey, defaultTags) {
    let intention
    if (statis && Object.keys(statis).length === 0) {
      intention = JSON.parse(JSON.stringify(defaultTags))
    } else if (statis && Object.keys(statis).length > 0) {
      intention = JSON.parse(JSON.stringify(statis))
    } else {
      return false
    }
    for (let langue in intention) {
      let langueLocale = langueObject[langue]
      langueLocale[langueKey] = {}
      for (let key in intention[langue]) {
        langueLocale[langueKey][key] = `${key}：${intention[langue][key]}`
      }
      vueThat.$i18n.mergeLocaleMessage(langue, langueObject[langue])
    }
  }
}
// export function getIntentionTags ({ collection, marketing, info_check, cod }, company) {
//   let langueObject = {
//     zh: zhLocale,
//     en: enLocale,
//     ba: baLocale
//   }
//   if (collection) getLangueTags({ statis: collectionTags, showTags: collection, company, langueKey: 'collectionTags', langueObject })
//   if (marketing) getLangueTags({ statis: marketingTags, showTags: marketing, company, langueKey: 'marketingTags', langueObject })
//   if (info_check) getLangueTags({ statis: infoCheckTags, showTags: info_check, company, langueKey: 'infoCheckTags', langueObject })
//   if (cod) getLangueTags({ statis: codTags, showTags: cod, company, langueKey: 'codTags', langueObject })

//   /**
//    * @description: 通过标签统计表获取标签的语言包
//    * @param {*} statis 标签统计表
//    * @param {*} showTags 后端返回的需要展示的tag列表
//    * @param {*} company 公司名
//    * @param {*} langueObject 国际化语言包
//    * @param {*} langueKey 国际化语言包对应的业务key值
//    * @return {*}
//    */
//   function getLangueTags ({ statis, showTags, company, langueKey, langueObject }) {
//     for (let langue in langueObject) {
//       let langueLocale = langueObject[langue]
//       let tagsKey = company in statis.en || company in statis.zh ? company : 'default'
//       langueLocale[langueKey] = {}
//       showTags.forEach(tag => {
//         langueLocale[langueKey][tag] = statis[langue][tagsKey][tag] || statis[langue].default[tag]
//       })
//       vueThat.$i18n.mergeLocaleMessage(langue, langueLocale)
//     }
//   }
// }



// WEBPACK FOOTER //
// ./src/utils/intentionTags/index.js